import React, { forwardRef } from "react";
import classNames from "classnames";
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import { Handle, Remove } from "../Item";
import InlineConfirm from "../InlineConfirm";
import styles from "./Container.module.css";

export const Container = forwardRef(
	(
		{
			children,
			header,
			handleProps,
			horizontal,
			hover,
			onClick,
			onRemove,
			shadow,
			unstyled,
			expanded = true,
			onToggleExpand,
			containerId,
			isPreviewMode,
			resources,
			isDragOverlay,
			hasValidationErrors = false,
			...props
		},
		ref
	) => {
		const handleExpandClick = (event) => {
			event.stopPropagation();
			onToggleExpand(containerId);
		};

		return (
			<div
				{...props}
				ref={ref}
				className={classNames(
					styles.Container,
					unstyled && styles.unstyled,
					horizontal && styles.horizontal,
					hover && styles.hover,
					shadow && styles.shadow,
					hasValidationErrors && styles.hasErrors
				)}
				tabIndex={onClick ? 0 : undefined}
			>
				<Accordion
					expanded={expanded}
					onChange={(event) => event.stopPropagation()}
					className={classNames(
						styles.Accordion,
						hasValidationErrors && styles.errorAccordion
					)}
				>
					<AccordionSummary
						expandIcon={
							<ExpandMoreIcon
								style={{
									transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
									transition: "transform 0.3s ease",
								}}
							/>
						}
						aria-controls={`panel-content-${containerId}`}
						id={`panel-header-${containerId}`}
						classes={{ root: styles.Header, content: styles.HeaderContent }}
						IconButtonProps={{
							className: styles.ExpandIcon,
							onClick: handleExpandClick,
						}}
					>
						<div
							className="d-flex align-items-center w-100"
							style={{ gap: "8px" }}
						>
							{hasValidationErrors && !expanded && (
								<Tooltip title={resources["ValidationErrors"]}>
									<ErrorOutlineIcon
										color="error"
										fontSize="small"
										style={{ flexShrink: 0 }}
									/>
								</Tooltip>
							)}

							{!isPreviewMode &&
								(isDragOverlay ? (
									<Handle {...handleProps} />
								) : (
									<Tooltip title={resources["DragToReorderTooltip"]}>
										<span>
											<Handle {...handleProps} />
										</span>
									</Tooltip>
								))}
							{header}
						</div>
						{onRemove && !isPreviewMode ? (
							<InlineConfirm onConfirm={onRemove} resources={resources}>
								<Tooltip title={resources["DeleteSegmentTooltip"]}>
									<span>
										<Remove id={`remove-segment-${containerId}`} />
									</span>
								</Tooltip>
							</InlineConfirm>
						) : undefined}
					</AccordionSummary>
					<AccordionDetails style={{ padding: 0 }}>
						<ul>{children}</ul>
					</AccordionDetails>
				</Accordion>
			</div>
		);
	}
);
